// import React, { useEffect } from "react";
// import { useMarket } from "./contexts/MarketContext";
// import { navigation } from "nr1";
// import GlobalDashboard from "./GlobalDashboard/GlobalDashboard";
// import MarketDashboard from "./market/MarketDashboard";

// /**
//  * DashboardRouter
//  * 
//  * Central routing component that determines whether to show:
//  * - GlobalDashboard (overview of all markets)
//  * - MarketDashboard (specific market operational health)
//  * 
//  * Responds to URL state changes and market context
//  */
// const DashboardRouter = () => {
//   const { 
//     viewMode, 
//     selectedMarket, 
//     // navigateToMarket, 
//     // navigateToGlobal 
//   } = useMarket();

//   // Sync URL state with context on mount
// //   useEffect(() => {
// //     const urlState = navigation.getOpenState();
    
// //     console.log('[DashboardRouter] URL State:', urlState);

// //     if (urlState?.market) {
// //       // Market specified in URL
// //       navigateToMarket(urlState.market);
// //     } else if (urlState?.view === 'global' || !urlState?.view) {
// //       // Default to global view
// //       navigateToGlobal();
// //     }
// //   }, []);

//   // Log current state for debugging
//   useEffect(() => {
//     console.log(`[DashboardRouter] View Mode: ${viewMode}, Selected Market: ${selectedMarket || 'None'}`);
//   }, [viewMode, selectedMarket]);

//   // Render appropriate dashboard based on view mode
//   return (
//     <div className="dashboard-router">
//       {viewMode === 'global' && <GlobalDashboard />}
//       {viewMode === 'market' && <MarketDashboard />}
      
//       {/* Fallback for invalid states */}
//       {!viewMode && (
//         <div className="dashboard-router-error">
//           <h2>Loading Dashboard...</h2>
//           <p>Initializing application state...</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DashboardRouter;
import React, { useEffect } from "react";
import { useMarket } from "./contexts/MarketContext";
import GlobalDashboard from "./GlobalDashboard/GlobalDashboard";
import MarketDashboard from "./market/MarketDashboard";


/**
 * DashboardRouter
 * Routes between Global and Market dashboards based on context
 */
const DashboardRouter = ({ userEmail, language, setLanguage }) => {
  const { viewMode, selectedMarket } = useMarket();

  // Log current state
  useEffect(() => {
    console.log(
      `[DashboardRouter] Mode: ${viewMode}, Market: ${selectedMarket || 'None'}, User: ${userEmail}`
    );
  }, [viewMode, selectedMarket, userEmail]);

  return (
    <div className="dashboard-router">
      {viewMode === 'global' && (
        <GlobalDashboard 
          userEmail={userEmail}
          language={language}
          setLanguage={setLanguage}
        />
      )}
      
      {viewMode === 'market' && (
        <MarketDashboard 
          userEmail={userEmail}
          language={language}
          setLanguage={setLanguage}
        />
      )}

      {!viewMode && (
        <div className="dashboard-router-loading">
          <div className="loading-spinner"></div>
          <h2>Loading Dashboard...</h2>
          <p>Initializing application state...</p>
        </div>
      )}
    </div>
  );
};

export default DashboardRouter;